<template>
  <label class="item-department">
    <input
      type="radio"
      name="department"
      class="item-department__input"
      :id="'rad' + item.departmentid"
      @change="emitToParent"
      :value="item"
      v-model="value"
    />
    <v-card
      class="item-department__container py-3 px-3 py-md-10 px-md-6 mx-3 mb-5 card text-center"
      outlined
      tile
      :style="
        'background-color: ' +
          this.user.config.parameters.parameters.colorprimary +
          ';' +
          'color: ' +
          this.user.config.parameters.parameters.colorbackground +
          ';'
      "
    >
      <span>&nbsp;</span>
      <span
        class="item-department__icon"
        :style="
          'background-color: ' +
            this.user.config.parameters.parameters.colorbackground +
            ';' +
            'color: ' +
            this.user.config.parameters.parameters.colorprimary +
            ';'
        "
        >✓</span
      >
      <div class="item-department__content">
        <div class="item-department__name">{{ this.item.name }}</div>
        <div class="item-department__address mt-3">{{ this.item.address }}</div>
        <div class="item-department__address">{{ this.item.zipcode }} {{ this.item.city }}</div>
      </div>
    </v-card>
  </label>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'itemDepartment',
  data() {
    return {
      value: false
    };
  },
  mounted() {
    this.setValue();
  },
  updated() {
    this.setValue();
  },
  props: {
    item: Object
  },
  methods: {
    setValue() {
      let rooftopid = this.user.selectedRooftopid;
      if (typeof rooftopid == 'undefined' || rooftopid.length == 0 || rooftopid == null || rooftopid == '') {
        setTimeout(() => {
          this.setValue();
        }, 1000);
      }
      if (rooftopid !== '') {
        this.value = this.user.lists.departments.output.filter(function(item) {
          return item.rooftopid === rooftopid;
        })[0];
      }
    },
    emitToParent() {
      this.$emit('childToParent', this.value);
    }
  },
  computed: mapGetters(['user'])
});
</script>

<style scoped lang="scss">
@import './src/assets/scss/_variables.scss';
.item-department {
  position: relative;

  &__name {
    font-weight: 600;
    padding: 0;
    letter-spacing: 0.03rem;
  }

  &__address {
    font-size: 0.75rem;
  }

  &__container {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      display: block;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 0.3s;
      border-radius: inherit;
    }
  }

  &__icon {
    width: 22px;
    height: 22px;
    line-height: 22px;
    position: absolute;
    display: block;
    margin: 6px 6px;
    top: 0;
    font-weight: 700;
    font-size: 1.1rem;
    right: 0;
    opacity: 0;
    z-index: 3;
    transform: translate(0, -3px);
    transition: transform 0.3s, opacity 0.3s;
    border-radius: 100px;
    background: $lightest;
    color: $primaryColorDark;

    @media (min-width: 960px) {
      & {
        margin: 12px 13px;
      }
    }
  }

  &__content {
    position: relative;
    z-index: 2;
  }

  &__input {
    opacity: 0;
    position: fixed;
    pointer-events: none;

    &:checked {
      + .item-department__container {
        box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
        //box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);

        &::before {
          opacity: 0.5;
          background: $darkest;
        }

        .item-department {
          &__icon {
            opacity: 1;
            transform: translate(0, 0px);
          }
        }
      }
    }
  }
}
</style>

<i18n src="../../localization/texts.json"></i18n>
